import { useMemo } from 'react';
import { useFetchPostComplex } from './useFetchPost';
import { generateParams } from './jsonData';

const usePageData = (pageKey, variation, type, blockIndex = null) => {
  // regenerate params when pageKey / variation / type changes
  const params = useMemo(
    () => generateParams(pageKey, variation, type),
    [pageKey, variation, type]
  );

  const result = useFetchPostComplex(
    params.endPointUrl,
    params.endPointParams,
    {
      //feeds: true,
      endPointUrlDNS: params.endPointUrlDNS
    }
  );

  if (blockIndex !== null) {
    return result?.data?.content?.content[blockIndex]?.data?.block_reference;
  }
  return result;
};

export default usePageData;
